<div *ngFor="let referenceableTypeIdKey of referenceableTypeIdKeys">
  <a
    *ngIf="linkFromTypeIdKey(referenceableTypeIdKey)"
    [href]="linkFromTypeIdKey(referenceableTypeIdKey)"
    target="_blank"
    class="small"
    >
    {{ linkLabelFromTypeIdKey(referenceableTypeIdKey) }}
  </a>
</div>